class HeaderHoverMenu {
  constructor() {
    this.isDesktop = window.matchMedia('(min-width: 990px)');
    this.activeTimeouts = new Map();
    this.init();
    
    // Re-inicializar quando mudar entre desktop/mobile
    this.isDesktop.addEventListener('change', () => {
      this.cleanup();
      this.init();
    });
  }

  init() {
    // Aguardar os elementos serem carregados
    setTimeout(() => {
      const headerMenus = document.querySelectorAll('header-menu');
      
      headerMenus.forEach(menu => {
        if (this.isDesktop.matches) {
          this.setupHoverBehavior(menu);
        }
      });
    }, 100);
  }

  setupHoverBehavior(menu) {
    const details = menu.querySelector('details');
    const summary = menu.querySelector('summary');
    
    if (!details || !summary) return;
    
    // Configurar clique para navegação no desktop
    // No desktop: clique navega para o link principal, hover abre submenu
    // No mobile: mantém comportamento original de clique para abrir/fechar
    const clickHandler = (event) => {
      if (this.isDesktop.matches) {
        event.preventDefault();
        event.stopPropagation();
        
        // Obter a URL do menu principal configurada no Liquid
        const menuUrl = summary.getAttribute('data-menu-url');
        
        // Se o menu tiver uma URL válida configurada, navegar para ela
        if (menuUrl && menuUrl !== '#' && menuUrl.trim() !== '') {
          window.location.href = menuUrl;
        }
      }
      // No mobile, o comportamento padrão do HeaderMenu será mantido
    };
    
    summary.addEventListener('click', clickHandler);
    
    // Configurar hover
    this.setupHoverEvents(menu, details, summary);
    
    // Configurar navegação por teclado
    this.setupKeyboardNavigation(menu, details, summary);
  }

  setupHoverEvents(menu, details, summary) {
    const menuId = this.getMenuId(menu);
    
    // Mouse enter no menu principal
    menu.addEventListener('mouseenter', () => {
      this.clearTimeout(menuId);
      if (this.isDesktop.matches && !details.hasAttribute('open')) {
        this.openSubmenu(details, summary);
      }
    });
    
    // Mouse leave no menu principal
    menu.addEventListener('mouseleave', () => {
      if (this.isDesktop.matches) {
        this.setCloseTimeout(menuId, () => {
          this.closeSubmenu(details, summary);
        });
      }
    });
    
    // Encontrar e configurar eventos no submenu
    const submenu = details.querySelector('.header__submenu, .mega-menu__content');
    if (submenu) {
      submenu.addEventListener('mouseenter', () => {
        this.clearTimeout(menuId);
      });
      
      submenu.addEventListener('mouseleave', () => {
        if (this.isDesktop.matches) {
          this.setCloseTimeout(menuId, () => {
            this.closeSubmenu(details, summary);
          });
        }
      });
    }
  }

  setupKeyboardNavigation(menu, details, summary) {
    summary.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        
        // Enter navega para o link principal (mesmo comportamento do clique)
        const menuUrl = summary.getAttribute('data-menu-url');
        
        if (menuUrl && menuUrl !== '#' && menuUrl.trim() !== '') {
          window.location.href = menuUrl;
        }
      }
      
      if (event.key === ' ') {
        event.preventDefault();
        
        // Espaço abre/fecha o submenu (para navegação por teclado)
        if (details.hasAttribute('open')) {
          this.closeSubmenu(details, summary);
        } else {
          this.openSubmenu(details, summary);
        }
      }
      
      if (event.key === 'Escape' && details.hasAttribute('open')) {
        this.closeSubmenu(details, summary);
        summary.focus();
      }
    });
  }

  openSubmenu(details, summary) {
    details.setAttribute('open', '');
    summary.setAttribute('aria-expanded', 'true');
    
    // Disparar evento para compatibilidade com código existente
    details.dispatchEvent(new Event('toggle', { bubbles: true }));
  }

  closeSubmenu(details, summary) {
    details.removeAttribute('open');
    summary.setAttribute('aria-expanded', 'false');
    
    // Disparar evento para compatibilidade com código existente
    details.dispatchEvent(new Event('toggle', { bubbles: true }));
  }

  setCloseTimeout(menuId, callback) {
    this.clearTimeout(menuId);

    const timeoutId = setTimeout(() => {
      this.activeTimeouts.delete(menuId);
      callback();
    }, 400);

    this.activeTimeouts.set(menuId, timeoutId);
  }

  clearTimeout(menuId) {
    if (this.activeTimeouts.has(menuId)) {
      clearTimeout(this.activeTimeouts.get(menuId));
      this.activeTimeouts.delete(menuId);
    }
  }

  getMenuId(menu) {
    const details = menu.querySelector('details');
    return details ? details.id || `menu-${Math.random().toString(36).substr(2, 9)}` : 'unknown';
  }

  cleanup() {
    // Limpar todos os timeouts ativos
    this.activeTimeouts.forEach(timeout => clearTimeout(timeout));
    this.activeTimeouts.clear();
  }
}

// Aguardar que todos os elementos customizados sejam carregados
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    // Aguardar um pouco mais para garantir que os custom elements estejam prontos
    setTimeout(() => {
      new HeaderHoverMenu();
    }, 200);
  });
} else {
  // Se o DOM já está carregado
  setTimeout(() => {
    new HeaderHoverMenu();
  }, 200);
} 